"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createFilter = createFilter;
exports.filterKeyValue = void 0;

var _diacritics = require("./diacritics");

function trimString(str) {
  return str.replace(/^\s+|\s+$/g, '');
}

function defaultStringify(option, filterByKey) {
  if (filterByKey) return "".concat(option.value, " ").concat(option.label);else return "".concat(option.label);
}

function createFilter(option, rawInput) {
  var filterByKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var ignoreCase = true;
  var ignoreAccents = true;
  var trim = true;
  var matchFrom = 'any';
  var input = trim ? trimString(rawInput) : rawInput;
  var candidate = trim ? trimString(defaultStringify(option, filterByKey)) : defaultStringify(option, filterByKey);

  if (ignoreCase) {
    input = input.toLowerCase();
    candidate = candidate.toLowerCase();
  }

  if (ignoreAccents) {
    input = (0, _diacritics.stripDiacritics)(input);
    candidate = (0, _diacritics.stripDiacritics)(candidate);
  }

  return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
}

var filterKeyValue = function filterKeyValue(option, rawInput) {
  return createFilter(option, rawInput, true);
};

exports.filterKeyValue = filterKeyValue;